export default "/images/tutorial_c.webp"